import HttpService from "./htttp.service";

export const setupAxiosInterceptors = ({
  onUnauthenticated,
  onUnauthorized,
}) => {
  const onRequestSuccess = async (config) => {
    const token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  };
  const onRequestFail = (error) => Promise.reject(error);

  const requestInterceptorId = HttpService.addRequestInterceptor(
    onRequestSuccess,
    onRequestFail,
  );

  const onResponseSuccess = (response) => response;

  const onResponseFail = (error) => {
    const status = error.status || error.response?.status;
    if (!status) {
      return Promise.reject(error);
    }
    if (/*status === 403 ||*/ status === 401) {
      onUnauthenticated();
    }

    if (status === 403) {
      if (onUnauthorized) onUnauthorized();
    }

    return Promise.reject(error);
  };
  const responseInterceptorId = HttpService.addResponseInterceptor(
    onResponseSuccess,
    onResponseFail,
  );

  return () => {
    HttpService.removeRequestInterceptor(requestInterceptorId);
    HttpService.removeResponseInterceptor(responseInterceptorId);
  };
};
